module.exports = __webpack_public_path__ + "media/components/composites/LumberDeckingCalculator/images/lumber-logo-f8a1260fb91a0da1b34f430223b23dad.png";